var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiquidityRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4405 30.7185L3.17383 33.3852L7.4405 36.0518V34.4518H17.5818C17.5808 34.4252 17.5738 34.3996 17.5738 34.3729C17.5738 33.982 17.6778 33.5958 17.8752 33.2577L18.4234 32.3185H7.4405V30.7185Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9074 9.38509L35.1741 6.71842L30.9074 4.05176V5.65176H18.1074V7.78509H30.9074V9.38509Z",
    fill: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9065 6.71851H13.8398V7.78517H14.9065V6.71851Z",
    fill: "#272D55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7737 6.71851H11.707V7.78517H12.7737V6.71851Z",
    fill: "#272D55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0393 6.71851H15.9727V7.78517H17.0393V6.71851Z",
    fill: "#272D55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1065 12.5851C26.1065 12.2907 25.8676 12.0518 25.5732 12.0518H6.37318C6.07878 12.0518 5.83984 12.2907 5.83984 12.5851V14.1851H26.1065V12.5851Z",
    fill: "#272D55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1065 15.2517H5.83984V16.3184H26.1065V15.2517Z",
    fill: "#272D55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7841 22.3081C27.5478 21.9033 27.1094 21.6516 26.6406 21.6516C26.1718 21.6516 25.7334 21.9033 25.4966 22.3081L18.7969 33.7951C18.695 33.97 18.6406 34.17 18.6406 34.3727C18.6406 35.0041 19.1548 35.5183 19.7862 35.5183H33.4945C34.1265 35.5183 34.6406 35.0041 34.6406 34.3727C34.6406 34.17 34.5862 33.97 34.4844 33.7945L27.7841 22.3081ZM26.6406 33.9183C26.0513 33.9183 25.574 33.4409 25.574 32.8516C25.574 32.2623 26.0513 31.7849 26.6406 31.7849C27.23 31.7849 27.7073 32.2623 27.7073 32.8516C27.7073 33.4409 27.23 33.9183 26.6406 33.9183ZM27.7073 28.5849C27.7073 29.1743 27.23 29.6516 26.6406 29.6516C26.0513 29.6516 25.574 29.1743 25.574 28.5849V25.3849C25.574 24.7956 26.0513 24.3183 26.6406 24.3183C27.23 24.3183 27.7073 24.7956 27.7073 25.3849V28.5849Z",
    fill: "#272D55"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37318 24.8517H22.778L24.5753 21.7711C24.9102 21.1962 25.4713 20.7967 26.1065 20.6501V17.385H5.83984V24.3183C5.83984 24.6127 6.07878 24.8517 6.37318 24.8517ZM18.1065 21.1183H21.3065V23.2517H18.1065V21.1183ZM12.7732 21.1183H15.9732V23.2517H12.7732V21.1183ZM7.43984 21.1183H10.6398V23.2517H7.43984V21.1183Z",
    fill: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquidityRisk);
export default __webpack_public_path__ + "static/media/LiquidityRisk.fc040c257087c047bdc068a6c1b4c3b2.svg";
export { ForwardRef as ReactComponent };